import * as P from "react";
import { jsx as x } from "react/jsx-runtime";
import { P as l, a as ye, i as de, d as pe, b as Ee } from "./DefaultPropsProvider-OJ3TZ31B.mjs";
import { w as Se, s as ve, T as Te, u as F, i as be, h as _e, E as Ce, c as Pe, a as xe } from "./identifier-Cgsu5TYh.mjs";
import { u as Re } from "./useThemeWithoutDefault-v0EqF6Qt.mjs";
var O = { exports: {} }, s = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y;
function $e() {
  if (Y) return s;
  Y = 1;
  var e = typeof Symbol == "function" && Symbol.for, o = e ? Symbol.for("react.element") : 60103, u = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, E = e ? Symbol.for("react.concurrent_mode") : 60111, S = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, $ = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function d(r) {
    if (typeof r == "object" && r !== null) {
      var _ = r.$$typeof;
      switch (_) {
        case o:
          switch (r = r.type, r) {
            case p:
            case E:
            case n:
            case i:
            case c:
            case v:
              return r;
            default:
              switch (r = r && r.$$typeof, r) {
                case m:
                case S:
                case b:
                case T:
                case f:
                  return r;
                default:
                  return _;
              }
          }
        case u:
          return _;
      }
    }
  }
  function y(r) {
    return d(r) === E;
  }
  return s.AsyncMode = p, s.ConcurrentMode = E, s.ContextConsumer = m, s.ContextProvider = f, s.Element = o, s.ForwardRef = S, s.Fragment = n, s.Lazy = b, s.Memo = T, s.Portal = u, s.Profiler = i, s.StrictMode = c, s.Suspense = v, s.isAsyncMode = function(r) {
    return y(r) || d(r) === p;
  }, s.isConcurrentMode = y, s.isContextConsumer = function(r) {
    return d(r) === m;
  }, s.isContextProvider = function(r) {
    return d(r) === f;
  }, s.isElement = function(r) {
    return typeof r == "object" && r !== null && r.$$typeof === o;
  }, s.isForwardRef = function(r) {
    return d(r) === S;
  }, s.isFragment = function(r) {
    return d(r) === n;
  }, s.isLazy = function(r) {
    return d(r) === b;
  }, s.isMemo = function(r) {
    return d(r) === T;
  }, s.isPortal = function(r) {
    return d(r) === u;
  }, s.isProfiler = function(r) {
    return d(r) === i;
  }, s.isStrictMode = function(r) {
    return d(r) === c;
  }, s.isSuspense = function(r) {
    return d(r) === v;
  }, s.isValidElementType = function(r) {
    return typeof r == "string" || typeof r == "function" || r === n || r === E || r === i || r === c || r === v || r === R || typeof r == "object" && r !== null && (r.$$typeof === b || r.$$typeof === T || r.$$typeof === f || r.$$typeof === m || r.$$typeof === S || r.$$typeof === h || r.$$typeof === A || r.$$typeof === g || r.$$typeof === $);
  }, s.typeOf = d, s;
}
var a = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D;
function he() {
  return D || (D = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, o = e ? Symbol.for("react.element") : 60103, u = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, m = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, E = e ? Symbol.for("react.concurrent_mode") : 60111, S = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, T = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, $ = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, A = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function d(t) {
      return typeof t == "string" || typeof t == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      t === n || t === E || t === i || t === c || t === v || t === R || typeof t == "object" && t !== null && (t.$$typeof === b || t.$$typeof === T || t.$$typeof === f || t.$$typeof === m || t.$$typeof === S || t.$$typeof === h || t.$$typeof === A || t.$$typeof === g || t.$$typeof === $);
    }
    function y(t) {
      if (typeof t == "object" && t !== null) {
        var M = t.$$typeof;
        switch (M) {
          case o:
            var C = t.type;
            switch (C) {
              case p:
              case E:
              case n:
              case i:
              case c:
              case v:
                return C;
              default:
                var N = C && C.$$typeof;
                switch (N) {
                  case m:
                  case S:
                  case b:
                  case T:
                  case f:
                    return N;
                  default:
                    return M;
                }
            }
          case u:
            return M;
        }
      }
    }
    var r = p, _ = E, G = m, U = f, W = o, X = S, J = n, B = b, H = T, K = u, Z = i, Q = c, ee = v, w = !1;
    function re(t) {
      return w || (w = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), I(t) || y(t) === p;
    }
    function I(t) {
      return y(t) === E;
    }
    function te(t) {
      return y(t) === m;
    }
    function oe(t) {
      return y(t) === f;
    }
    function ne(t) {
      return typeof t == "object" && t !== null && t.$$typeof === o;
    }
    function se(t) {
      return y(t) === S;
    }
    function ae(t) {
      return y(t) === n;
    }
    function ce(t) {
      return y(t) === b;
    }
    function fe(t) {
      return y(t) === T;
    }
    function ie(t) {
      return y(t) === u;
    }
    function ue(t) {
      return y(t) === i;
    }
    function le(t) {
      return y(t) === c;
    }
    function me(t) {
      return y(t) === v;
    }
    a.AsyncMode = r, a.ConcurrentMode = _, a.ContextConsumer = G, a.ContextProvider = U, a.Element = W, a.ForwardRef = X, a.Fragment = J, a.Lazy = B, a.Memo = H, a.Portal = K, a.Profiler = Z, a.StrictMode = Q, a.Suspense = ee, a.isAsyncMode = re, a.isConcurrentMode = I, a.isContextConsumer = te, a.isContextProvider = oe, a.isElement = ne, a.isForwardRef = se, a.isFragment = ae, a.isLazy = ce, a.isMemo = fe, a.isPortal = ie, a.isProfiler = ue, a.isStrictMode = le, a.isSuspense = me, a.isValidElementType = d, a.typeOf = y;
  }()), a;
}
process.env.NODE_ENV === "production" ? O.exports = $e() : O.exports = he();
var Ae = O.exports, z = Ae, ge = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Me = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, j = {};
j[z.ForwardRef] = ge;
j[z.Memo] = Me;
var L = function(o, u) {
  var n = arguments;
  if (u == null || !_e.call(u, "css"))
    return P.createElement.apply(void 0, n);
  var c = n.length, i = new Array(c);
  i[0] = Ce, i[1] = Pe(o, u);
  for (var f = 2; f < c; f++)
    i[f] = n[f];
  return P.createElement.apply(null, i);
};
(function(e) {
  var o;
  o || (o = e.JSX || (e.JSX = {}));
})(L || (L = {}));
var Oe = /* @__PURE__ */ Se(function(e, o) {
  var u = e.styles, n = ve([u], void 0, P.useContext(Te)), c = P.useRef();
  return F(function() {
    var i = o.key + "-global", f = new o.sheet.constructor({
      key: i,
      nonce: o.sheet.nonce,
      container: o.sheet.container,
      speedy: o.sheet.isSpeedy
    }), m = !1, p = document.querySelector('style[data-emotion="' + i + " " + n.name + '"]');
    return o.sheet.tags.length && (f.before = o.sheet.tags[0]), p !== null && (m = !0, p.setAttribute("data-emotion", i), f.hydrate([p])), c.current = [f, m], function() {
      f.flush();
    };
  }, [o]), F(function() {
    var i = c.current, f = i[0], m = i[1];
    if (m) {
      i[1] = !1;
      return;
    }
    if (n.next !== void 0 && be(o, n.next, !0), f.tags.length) {
      var p = f.tags[f.tags.length - 1].nextElementSibling;
      f.before = p, f.flush();
    }
    o.insert("", n, f, !1);
  }, [o, n.name]), null;
});
function we(e) {
  return e == null || Object.keys(e).length === 0;
}
function k(e) {
  const {
    styles: o,
    defaultTheme: u = {}
  } = e;
  return /* @__PURE__ */ x(Oe, {
    styles: typeof o == "function" ? (c) => o(we(c) ? u : c) : o
  });
}
process.env.NODE_ENV !== "production" && (k.propTypes = {
  defaultTheme: l.object,
  styles: l.oneOfType([l.array, l.string, l.object, l.func])
});
const Ie = ye();
function Ne(e = Ie) {
  return Re(e);
}
function V({
  styles: e,
  themeId: o,
  defaultTheme: u = {}
}) {
  const n = Ne(u), c = typeof e == "function" ? e(o && n[o] || n) : e;
  return /* @__PURE__ */ x(k, {
    styles: c
  });
}
process.env.NODE_ENV !== "production" && (V.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: l.object,
  /**
   * @ignore
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool]),
  /**
   * @ignore
   */
  themeId: l.string
});
const Fe = (e) => {
  var n;
  const o = {
    systemProps: {},
    otherProps: {}
  }, u = ((n = e == null ? void 0 : e.theme) == null ? void 0 : n.unstable_sxConfig) ?? pe;
  return Object.keys(e).forEach((c) => {
    u[c] ? o.systemProps[c] = e[c] : o.otherProps[c] = e[c];
  }), o;
};
function Ye(e) {
  const {
    sx: o,
    ...u
  } = e, {
    systemProps: n,
    otherProps: c
  } = Fe(u);
  let i;
  return Array.isArray(o) ? i = [n, ...o] : typeof o == "function" ? i = (...f) => {
    const m = o(...f);
    return de(m) ? {
      ...n,
      ...m
    } : n;
  } : i = {
    ...n,
    ...o
  }, {
    ...c,
    sx: i
  };
}
function q(e) {
  return /* @__PURE__ */ x(V, {
    ...e,
    defaultTheme: Ee,
    themeId: xe
  });
}
process.env.NODE_ENV !== "production" && (q.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool])
});
function ke(e) {
  return function(u) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ x(q, {
        styles: typeof e == "function" ? (n) => e({
          theme: n,
          ...u
        }) : e
      })
    );
  };
}
function Ve() {
  return Ye;
}
export {
  Ye as e,
  ke as g,
  Ve as i,
  Ne as u
};
